module.exports = __webpack_public_path__ + "static/lageplan_kinderbetreuung_mini-f2a3948122ca1da0ccf610d5636f4134.png";